import { render, staticRenderFns } from "./TraitsForm.vue?vue&type=template&id=f9552c8a&scoped=true&"
import script from "./TraitsForm.vue?vue&type=script&lang=js&"
export * from "./TraitsForm.vue?vue&type=script&lang=js&"
import style0 from "./TraitsForm.vue?vue&type=style&index=0&id=f9552c8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9552c8a",
  null
  
)

export default component.exports